import styled from "styled-components";

export const Title = styled.div`
  font-size: 2rem;
  font-weight: bold;
`

export const HeaderPage = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`